// extracted by mini-css-extract-plugin
module.exports = {"getInTouch":"get-contact-section-module--getInTouch--1oPyP"};